import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "The Characters", href: "#characters" },
    { label: "The Books", href: "#books" },
    { label: "Reviews", href: "#reviews" },
    { label: "About Author", href: "#about" },
    { label: "Contact", href: "#contact" },
  ];

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
    setMobileOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md shadow-md shadow-foreground-950/10"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <h1 className="m-0 p-0 text-base font-normal">
            <a
              href="/"
              className="flex items-center gap-2 font-bold text-lg md:text-xl text-foreground-950 whitespace-nowrap"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              <img
                alt="Cappy and Barry Adventures"
                className="w-10 h-10 md:w-12 md:h-12 object-contain"
                src="../../../../images/0ceb999f35a931c1da96a7ccbbd5c92f.png"
              />
              <div className="flex flex-col">
                <span className="text-foreground-950">Cappy &amp; Barry</span>
                <span className="text-xs text-foreground-500 font-normal tracking-wide italic">
                  Little stories. Big feelings. Gentle lessons.
                </span>
              </div>
            </a>
          </h1>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className="text-foreground-700 hover:text-primary-500 transition-colors font-medium whitespace-nowrap"
              >
                {link.label}
              </button>
            ))}
            <a
              href="https://cappybarry.gumroad.com/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="bg-primary-500 text-white px-5 py-2.5 rounded-full font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Get the Books
              <i className="ri-arrow-right-line ml-1" />
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className="ri-menu-line text-xl" />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className="text-foreground-700 hover:text-primary-500 transition-colors font-medium text-left py-2"
              >
                {link.label}
              </button>
            ))}
            <a
              href="https://cappybarry.gumroad.com/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="bg-primary-500 text-white px-5 py-2.5 rounded-full font-medium hover:bg-primary-600 transition-colors text-center whitespace-nowrap mt-2"
            >
              Get the Books
              <i className="ri-arrow-right-line ml-1" />
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}